import { render, staticRenderFns } from "./Proprietary_goods.vue?vue&type=template&id=095c5e93&scoped=true"
import script from "./Proprietary_goods.vue?vue&type=script&lang=js"
export * from "./Proprietary_goods.vue?vue&type=script&lang=js"
import style0 from "./Proprietary_goods.vue?vue&type=style&index=0&id=095c5e93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095c5e93",
  null
  
)

export default component.exports